import { EngineNames } from '../../../../services/wss/events/EngineNames';
import logService from '../../../../services/wss/logService3';
import { JournalStates } from '../../../../utils/journalStates';

const _engine = EngineNames.TemplateEngine;
const _name = 'OnJournalUpdatedHandler';

/**
 * Handles the OnJournalUpdated event.
 * Updates the matching entry in the search result cache in-place.
 * Only dependency is SearchCache — fully testable in isolation.
 */
export default class OnJournalUpdatedHandler {
    constructor(cache) {
        this._cache = cache;
    }

    /**
     * @param {object[]} entries - Updated entries from BE
     * @returns {boolean} True if any entry was found and updated
     */
    handle = (entries) => {
        try {
            if (!entries?.length) {
                return false;
            }

            let updated = false;
            entries.forEach((x) => {
                if (x.stateId !== JournalStates.Approved) {
                    return;
                }

                // add it to cache
                this._cache.addOrUpdate([x]);
                updated = true;
            });

            return updated;
        } catch (error) {
            logService.logError(`${_engine}.{_name}.handle: ${error.message}`);
            return false;
        }
    };
}
